import { Component } from '@angular/core';

@Component({
  selector: 'lohi-app-dashboard',
  templateUrl: './lohi-dashboard.component.html',
  styleUrls: ['./lohi-dashboard.component.scss'],
})
export class LohiDashboardComponent {}
